import React from 'react';
import { Flex, Box, Text, Link } from 'rebass';

import { FormHeader, FormSubHeader } from '@mdlinx/component-library';

import { FormContainer } from 'app/components/layout/form-container';

export type SignUpThankYouProps = {
  onCloseLinkClicked: () => void;
  thankYouText: string;
  textAlignment: string;
};

export const SignUpThankYou = ({ onCloseLinkClicked, thankYouText, textAlignment }: SignUpThankYouProps) => (
  <FormContainer>
    <Flex flexDirection="column" alignItems={textAlignment}>
      <FormHeader>Thank you</FormHeader>
      <Box mt="12px" />
      <Text maxWidth="370px" sx={{ flexGrow: 1 }}>
        <FormSubHeader>{thankYouText}</FormSubHeader>
      </Text>
      <Link
        flex="1 0 auto"
        as="a"
        mt="20px"
        onClick={e => {
          e.preventDefault();
          onCloseLinkClicked();
        }}
        css={{
          color: '#13284c',
          fontSize: '16px',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        <Text fontFamily="label" fontSize="16px" color="blue">
          Close
        </Text>
      </Link>
    </Flex>
  </FormContainer>
);
